import type { FormikProps } from "formik";

export function fieldTouchedError<T extends Record<string, unknown>>(
  formik: Pick<FormikProps<T>, "touched" | "errors">,
  field: keyof T & string
): string | undefined {
  if (!formik.touched[field as keyof typeof formik.touched]) return undefined;
  const err = formik.errors[field as keyof typeof formik.errors];
  return typeof err === "string" ? err : undefined;
}

export function getFieldError(
  touched: Record<string, unknown>,
  errors: Record<string, unknown>,
  field: string
): string | undefined {
  if (!touched[field]) return undefined;
  const err = errors[field];
  return typeof err === "string" ? err : undefined;
}
